import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore Categorias
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Navegue pelas nossas categorias curadas e encontre os melhores produtos da China com precos imperdiveis
          </p>
        </div>

        {/* Category Grid with images */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer bg-background-50 hover:scale-[1.02]"
            >
              {/* Product Image */}
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`HoobuySpreadsheet - ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/* Arrow indicator */}
                <span className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full bg-white/90 text-primary-600 text-xs opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-1 group-hover:translate-y-0">
                  <i className="ri-arrow-right-up-line"></i>
                </span>

                {/* Icon overlay */}
                <div className="absolute bottom-2 left-2 w-7 h-7 flex items-center justify-center rounded-full bg-white/80 backdrop-blur-sm">
                  <i className={`${cat.icon} text-xs text-primary-600`}></i>
                </div>
              </div>

              {/* Category Name */}
              <div className="px-3 py-3">
                <span className="text-xs md:text-sm font-semibold text-foreground-800 text-center block whitespace-nowrap group-hover:text-primary-600 transition-colors duration-200">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-10 md:mt-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Ver Todas as Categorias
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}